import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-homepage-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './homepage-footer.component.html',
  styleUrls: ['./homepage-footer.component.scss']
})
export class HomepageFooterComponent {
  //@Input() clientLogoSrc: string = 'client-logo.svg';
  @Input() clientLogoSrc: string = 'logos/clients/client-logo.svg';
  @Input() clientText: string = `Company Inc., All rights reserved ©${new Date().getFullYear()}`;
  @Input() riminiLogoSrc: string = 'logos/brand/riministreet-white.svg';
}
